import { faFileAudio, faSignalStream } from "@fortawesome/pro-solid-svg-icons";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages";
import { lazyRouteWithGuards } from "../../components/Routes/Functions/LazyRouteFunction";
import { createLazyRoleCheckGuard } from "../../components/Routes/Guards/LazyRoleCheckGuard";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { IFeature } from "../iFeature";

const requiredRole = AppRole.TranscriptionFeature;

export const transcriptionFeature: IFeature = {
  requiredRole,
  route: {
    path: RouteConstants.Transcription,
    lazy: lazyRouteWithGuards({
      importer: () => import("./TranscriptionPage"),
      componentName: "TranscriptionPage",
      guards: [createLazyRoleCheckGuard(requiredRole)],
    }),
  },
  menuItem: {
    id: "transcription",
    label: translationKeys.feature.transcription.link,
    breadCrumbTitle: translationKeys.feature.transcription.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.Transcription].join("/")}`,
    path: RouteConstants.Transcription,
    showFooter: true,
    hasSideBar: false,
    fontAwesomeIcon: faSignalStream,
  },
  card: (
    <FeatureCard
      featureKey="transcription"
      requiresBudget={true}
      featureIcon={faSignalStream}
      buttonIcon={faFileAudio}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.Transcription}
    />
  ),
};
